import script from "./CCSwiper.vue?vue&type=script&setup=true&lang=js"
export * from "./CCSwiper.vue?vue&type=script&setup=true&lang=js"

import "./CCSwiper.vue?vue&type=style&index=0&id=78db3471&lang=less"

const __exports__ = script;

export default __exports__